export default "__VITE_ASSET__4BZDOZZD__"